import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function table__loadingSkeleton() {
    return (
        <tr>
            <td>
                <Skeleton count={1} height={17} width={17} />
            </td>
            <td>
                <Skeleton count={1} height={50} width={50} />
            </td>
            <td>
                <Skeleton count={1} height={20} />
            </td>
            <td>
                <Skeleton count={1} height={20} />
            </td>
            <td>
                <Skeleton count={1} height={20} />
            </td>
            <td>
                <Skeleton count={1} height={20} />
            </td>
            <td>
                <div className="d-flex">
                    <Skeleton
                        circle={true}
                        count={1}
                        height={20}
                        width={20}
                        className="me-1" 
                    />

                    <Skeleton
                        circle={true}
                        count={1}
                        height={20}
                        width={20} 
                    />
                </div>
            </td>

        </tr>
    )
}

export default memo(table__loadingSkeleton)